import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { CheckCreditResponse, SerialCreditApplicationRequest, SerialCreditApplicationResponse } from '../models/models'

export class CheckSerialCreditApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/check-serial-credit',
      ...props,
    })
  }

  public async checkCredit(request: SerialCreditApplicationRequest): Promise<CheckCreditResponse> {
    return await this.postAsync<CheckCreditResponse>(request)
  }
}
